import { DateHelper } from "shared/helpers/DateHelper";
import { setIsAddingTaskWithEnter } from "shared/itemLists/redux/itemListsSlice";
import { getActItems } from "shared/itemLists/redux/selectors/getActItems";
import { insertionIndex } from "shared/itemLists/CursorItemsCoordinator/functions/cursorFunctions";

//adding

export function addBlankTaskCaseLogic(state, action) {
  const { position, selectedDate } = unpackABTPayload(state, action.payload);

  const tempNewTask = {
    ...state.newTask,
    name: "",
    position: position,
    initiated: true,
    selectedDate: selectedDate,
  };
  state.newTask = tempNewTask;
  state.insertStatus.hasBlankTask = true;
  state.items.splice(
    position,
    0,
    renderedEmptyTask(tempNewTask, state.localIdIncrementor)
  );
  state.localIdIncrementor += 1;
}

function unpackABTPayload(state, payload) {
  if (payload.listType === "Plan") {
    return payload;
  } else if (payload.listType === "Act") {
    const beforeItem = getActItems(state)[payload.position - 1];
    let position;
    let selectedDate;
    if (beforeItem === undefined) {
      // at beginning of list
      return { position: 0, selectedDate: state.today };
    } else if (beforeItem.type === "day_name") {
      position =
        state.items.findIndex((item) => beforeItem.day === item.day) + 1;
      position = insertionIndex(position, state.items);
    } else {
      position = state.items.findIndex((item) => beforeItem.id === item.id) + 1;
    }
    selectedDate = DateHelper.parseDate(beforeItem.day);
    return { position, selectedDate };
  }
}

function renderedEmptyTask(task, localIdIncrementor) {
  return {
    id: "unsaved-item-" + localIdIncrementor,
    type: "new_task",
    time: null,
    time_in_minutes: null,
    name: "",
    task_type: "flexible",
    day: DateHelper.dateString(task.selectedDate),
    blank: "true",
  };
}

//saving

export const saveNewTaskThunkAction = (payload = {}) => (
  dispatch,
  getState
) => {
  const { method } = payload;
  const state = getState();
  const task = newTaskBody(state);
  const position = state.itemLists.newTask.position;
  const localId = state.itemLists.items[state.itemLists.newTask.position].id;
  const effect = {
    url: "items",
    json: task,
    method: "POST",
  };
  dispatch({
    type: "itemLists/saveNewTask",
    payload: {
      task,
      method,
      position,
    },
    meta: {
      offline: {
        effect: effect,
        commit: {
          type: "itemLists/saveNewTask.commit",
          meta: { localId: localId },
        },
      },
    },
  });
  if (method === "enter") {
    setTimeout(() => {
      dispatch(setIsAddingTaskWithEnter(false));
    }, 10);
  }
};

export function saveNewTaskCaseLogic(state, action) {
  const { task, method } = action.payload;
  const { items, newTask } = state;
  const { position } = newTask;
  const taskToInsert = {
    ...task,
    id: items[position].id,
    type: "task",
    task_type: "flexible",
    time: null,
    time_in_minutes: null,
    day: DateHelper.dateString(task.day),
  };

  if (items[position].empty) {
    // if the day the task in is empty...
    const newDay = { ...items[position], empty: false };
    state.insertStatus.hasEmptyDay = false;

    state.items = [
      ...items.slice(0, position),
      newDay,
      taskToInsert,
      ...items.slice(position + 1),
    ];
  } else {
    state.items.splice(position, 1, taskToInsert);
  }

  state.insertStatus.hasBlankTask = false;
  state.newTask = { ...newTask, position: null, initiated: false, name: "" };
  if (method === "enter") {
    state.insertStatus.isAddingTaskWithEnter = true;
  }
}

export function newTaskBody(state) {
  const { items, newTask } = state.itemLists;
  const { primaryCalendarId } = state.auth;
  const { position, name, selectedDate } = newTask;
  return {
    name: name,
    day: selectedDate,
    item_type: "task",
    secondary_type: 0,
    on_day_index: newTaskOnDayIndex(items, position),
    calendar_id: primaryCalendarId,
  };
}

function newTaskOnDayIndex(items, position) {
  if (
    items[position - 1] &&
    Number.isInteger(items[position - 1].on_day_index)
  ) {
    return items[position - 1].on_day_index + 1;
  } else {
    return 0;
  }
}

export function commitItemCaseLogic(state, action) {
  const { localId } = action.meta;
  const { openItem } = state;
  const position = state.items.findIndex((item) => item.id === localId);
  state.items[position].id = action.payload.id;
  if (openItem.isOpen && openItem.details.id === localId) {
    openItem.details.id = action.payload.id;
  }
}

export function addEmptyDayCaseLogic(state, action) {
  const { selectedDate } = action.payload;
  const dh = new DateHelper(state.today);
  const emptyDay = {
    day: DateHelper.dateString(selectedDate),
    day_name: dh.getDayNameLong(selectedDate),
    empty: "true",
    type: "day_name",
  };
  insertDay(state, selectedDate, emptyDay, state.items);
  state.insertStatus.hasEmptyDay = true;
}

function insertDay(state, dateToInsert, dayToInsert, items) {
  let insertIndex = null;
  for (let i = 0; i < items.length; i++) {
    if (dateToInsert.getTime() < DateHelper.parseDate(items[i].day).getTime()) {
      insertIndex = i;
      break;
    }
  }
  insertIndex = insertIndex || items.length;
  state.items.splice(insertIndex, 0, dayToInsert);
}
